/**
 * Bill Payment actions
 */
import Constants from '../../constants';

const { BillPayments } = Constants;

/**
 * Action object dispatched to get bill payments
 *
 * @param {string} userId the user id
 * @param {object} params query params
 */
const getBillPayments = (userId, params) => ({
  type: BillPayments.GET_BILL_PAYMENTS,
  userId,
  params,
});

/**
 * Action object dispatched when unable to fetch bill payments
 *
 * @param {object} error error object
 */
const getBillPaymentsError = (error) => ({
  type: BillPayments.GET_BILL_PAYMENTS_ERROR,
  error,
});

/**
 * Action object dispatched when bill payment is fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {string} count: total count of bill payments that match the request query
 *   @property {object} billPayments: all fetched bill payments
 * }
 */
const getBillPaymentsSuccess = ({ count, billPayments }) => ({
  type: BillPayments.GET_BILL_PAYMENTS_SUCCESS,
  count,
  billPayments,
});

const getBillPayment = (userId, billPaymentId) => ({
  type: BillPayments.GET_BILL_PAYMENT,
  userId,
  billPaymentId,
});

/**
 * Action object dispatched when unable to fetch bill payment
 *
 * @param {object} error error object
 */
const getBillPaymentError = (error) => ({
  type: BillPayments.GET_BILL_PAYMENT_ERROR,
  error,
});

/**
 * Action object dispatched when bill payment is fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {string} count: total count of bill payments that match the request query
 *   @property {object} billPayments: all fetched bill payments
 * }
 */
const getBillPaymentSuccess = ({ billPayment }) => ({
  type: BillPayments.GET_BILL_PAYMENT_SUCCESS,
  billPayment,
});

export default {
  getBillPayments,
  getBillPaymentsError,
  getBillPaymentsSuccess,
  getBillPayment,
  getBillPaymentError,
  getBillPaymentSuccess,
};
